import { useEffect, useRef } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

import Box from "@mui/material/Box";

import MainPage from "../page/mainPage/mainPage";
import SignUp from "../page/signUp/SignUp";
import SignIn from "../page/signIn/SignIn";
import MakePress from "../page/myPress/MakePress";
import MyTotalList from "../page/myWorkSpace/MyTotalList";
import MyCompleteList from "../page/myWorkSpace/MyCompleteList";
import MyIngList from "../page/myWorkSpace/MyIngList";
import RequestHongbo from "../page/myWorkSpace/RequestHongbo";
import MyHongboIng from "../page/myWorkSpace/MyHongboIng";
import MyTheme from "../page/theme/MyTheme";
import CommonTheme from "../page/theme/CommonTheme";
import Settings from "../page/account/Settings";
import SearchPress from "../page/search/SearchPress";
import MngUser from "../page/mngUser/MngUser";

import { userState } from "../interface/MainInterface";
import * as AuthMain from "../auth/AuthMain";
import Toast from "../utils/Toast";
import PopThemeSelect from "../page/theme/PopThemeSelect";
import SearchFilterPress from "../page/search/SearchFilterPress";
import OptionPage from "../page/optionPage/OptionPage";
import HartLogIn from "../page/signIn/HartLogIn";
import PendingApproval from "../page/signIn/PendingApproval";
import MngUser2 from "../page/mngUser/MngUser2";
import Calendar from "../page/calendar/Calendar";
import SpellCheck from "../page/spellCheck/SpellCheck";
import MakePressCheck from "../page/spellCheck/MakePressCheck";
import MakePressCheck2 from "../page/spellCheck/MakePressCheck2";
import MakePressCheck2_1 from "../page/spellCheck/MakePressCheck2_1";
import MyDesking from "../page/myWorkSpace/MyDesking";
import MakePressCheck2_2 from "../page/spellCheck/MakePressCheck2_2";
import SsoLogin from "../page/signIn/SsoLogin";
import HaiSsoLogin from "../page/signIn/HaiSsoLogin";
import NewPressReleasePage from "../page/monitor/NewPressReleasePage";
import KeywordConfigPage from "../page/monitor/KeywordConfigPage";
import MonitoringCreatePage from "../page/monitor/MonitoringCreatePage";
import MonitoringDashboardCustomizedPage from "../page/monitor/MonitoringDashboardCustomizedPage";
import NewMonitoringListPage from "../page/monitor/NewMonitoringListPage";
import PublisherReporterSentimentStatsPage from "../page/monitor/PublisherReporterSentimentStatsPage";

interface propsType {
  userState: userState;
  drawerWidth: number;
  setSelectedMenu: any;
  winSize: string;
  getLeftCount: any;
  searchResult: any;
  setSearchResult: any;
}

const MainConteiner = (props: propsType) => {
  const location = useLocation();
  const toastRef: any = useRef();

  useEffect(() => {
    const sessionCheck = async () => {
      try {
        if (!AuthMain.getSession() && !(await AuthMain.checkAuthenticated())) {
          moveHome();
        } else {
          props.setSelectedMenu(`/${location.pathname.split("/")[1]}`);
        }
      } catch (error) {
        moveHome();
      }
    };

    const moveHome = () => {
      toastRef.current?.toast(
        "세션이 종료되었습니다.\n로그인 화면으로 이동합니다.",
        "error",
        4000,
        {
          vertical: "top",
          horizontal: "center",
        }
      );
      setTimeout(() => {
        window.location.href = "/hartlogin";
      }, 3000);
    };

    // console.log("location.pathname :", location.pathname);
    if (
      location.pathname === "/" ||
      location.pathname === "/signin" ||
      location.pathname === "/signup" ||
      location.pathname === "/hartlogin" ||
      location.pathname === "/haiSsoLogin" ||
      location.pathname === "/unapproved"
    ) {
      props.setSelectedMenu(`/${location.pathname.split("/")[1]}`);
    } else {
      sessionCheck();
    }
  }, [location, props]);

  return (
    <Box
      sx={{
        ml: `${props.drawerWidth}px`,
        transition: "margin 0.5s",
        height: "calc(100vh - 44px)",
      }}
    >
      <Routes>
        <Route path="/" element={<MainPage userState={props.userState} />} />
        <Route
          path="/signup"
          element={<SignUp userState={props.userState} />}
        />
        <Route
          path="/signin"
          element={<SignIn userState={props.userState} />}
        />
        <Route
          path="/hartlogin"
          element={<HartLogIn userState={props.userState} />}
        />
        <Route
          path="/ssologin"
          element={<SsoLogin userState={props.userState} />}
        />
        <Route
          path="/haiSsoLogin"
          element={<HaiSsoLogin />}
        />
        <Route
          path="/unapproved"
          element={<PendingApproval />}
        />

        {props.userState.isAuth && (
          <>
            <Route
              path="/makePress/:pressSeq"
              element={
                <MakePress
                  userState={props.userState}
                  getLeftCount={props.getLeftCount}
                />
              }
            />
            <Route
              path="/myTotalList"
              element={<MyTotalList userState={props.userState} />}
            />
            <Route
              path="/myCompleteList"
              element={<MyCompleteList userState={props.userState} />}
            />
            <Route
              path="/myIngList"
              element={<MyIngList userState={props.userState} />}
            />
            <Route
              path="/myTheme"
              element={
                <MyTheme
                  userState={props.userState}
                  startMode={"view"}
                  selectTheme={() => {}}
                  height="calc(100vh - 151px)"
                />
              }
            />

            <Route
              path="/searchPress"
              element={
                <SearchPress
                  userState={props.userState}
                  searchResult={props.searchResult}
                  setSearchResult={props.setSearchResult}
                />
              }
            />
            <Route
              path="/searchFilterPress"
              element={
                <SearchFilterPress
                  userState={props.userState}
                  searchResult={props.searchResult}
                  setSearchResult={props.setSearchResult}
                />
              }
            />
            <Route
              path="/spellCheck"
              element={
                <SpellCheck 
                  userState={props.userState}
                />
              }
            />
            <Route
              path="/optionPage"
              element={
                <OptionPage
                  userState={props.userState}
                  getLeftCount={props.getLeftCount}
                />
              }
            />
            <Route
              path="/setting"
              element={<Settings userState={props.userState} />}
            />
            {props.userState.isAdmin && (
              <>
                <Route
                  path="/mngUser"
                  element={<MngUser2 userState={props.userState} />}
                />
                {/* <Route
                  path="/mngUser2"
                  element={<MngUser2 userState={props.userState} />}
                /> */}
                <Route
                  path="/commonTheme"
                  element={
                    <CommonTheme
                      userState={props.userState}
                      startMode={"view"}
                      selectTheme={() => {}}
                      height="calc(100vh - 151px)"
                    />
                  }
                />
                <Route
                  path="/requestHongbo"
                  element={<RequestHongbo userState={props.userState} />}
                />
                <Route
                  path="/myHongboIng"
                  element={<MyHongboIng userState={props.userState} />}
                />
                <Route
                  path="/myDesking"
                  element={<MyDesking userState={props.userState} />}
                />
                <Route
                  path="/calendar"
                  element={
                    <Calendar
                      userState={props.userState}
                      drawerWidth={props.drawerWidth}
                    />
                  }
                />
                <Route
                  path="/aiDesk/:pressSeq"
                  element={
                    <MakePressCheck2_1 userState={props.userState}/>
                  }
                />
                <Route path="/pressRelease" element={<NewMonitoringListPage userState={props.userState} />} />
                <Route path="/pressRelease/detail" element={<NewPressReleasePage userState={props.userState} />} />
                <Route path="/monitoringCreate" element={<MonitoringCreatePage userState={props.userState} />} />
                <Route path="/keywordConfig" element={<KeywordConfigPage />} />
                <Route path="/monitoringDashboard" element={<MonitoringDashboardCustomizedPage userState={props.userState} />} />
                <Route path="/publisherReporterStats" element={<PublisherReporterSentimentStatsPage />} />
              </>
            )}
          </>
        )}
        
        <Route path="*" element={<Navigate replace to="/" />} />
      </Routes>
      <Toast ref={toastRef} />
    </Box>
  );
};

export default MainConteiner;
